import {
  getEquipAreaList,
  equipmentAreaTemplate,
  importEquipmentAreas,
} from "@ckweb/ckfetch/connectables/equipmentAreaManagement";
import { getInspectionZoneList } from "@ckweb/ckfetch/connectables/inspectionManagement";
import { getWorkpackFilterLookupList } from "@ckweb/ckfetch/connectables/transactions";

const FETCH_ID = "EquipmentAreas";

export const useGetEquipmentAreasTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, equipmentAreaTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetEquipmentAreas = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getEquipAreaList, {
    fallback: [],
  });

export const useSubmitEquipmentAreas = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importEquipmentAreas, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });

export const useGetEquipmentTaskHeightList = () =>
  useSafeLocalFetch(
    `fetch${FETCH_ID}TaskHeightList`,
    // TODO: what endpoint can we use?
    getWorkpackFilterLookupList,
    {
      fallback: (data) => {
        // TODO: taken from ckClient, when endpoint is set, remove
        return (
          data?.taskHeightList || [
            { number: 0, name: "Exterior" },
            { number: 1, name: "Drains" },
            { number: 2, name: "Floor" },
            { number: 3, name: "Asset" },
            { number: 4, name: "Above Asset" },
            { number: 5, name: "Ceiling" },
          ]
        );
      },
    },
  );

export const useGetInspectionZonesList = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}InspectionZones`, getInspectionZoneList, {
    fallback: [],
  });
